import React from 'react';
import { Link, usePage } from '@inertiajs/react';
import { cn } from '../../utils/cn';
import { Avatar } from '../Avatar';
import { ImpersonationBanner } from '../ImpersonationBanner';
import { affiliate_dashboard_path, affiliate_sign_out_path, root_path } from '../../../lib/routes';
import { useFlash } from './useFlash';
export function AffiliateLayout({ children }) {
  const { props, url } = usePage();
  const appName = props.app_name ?? 'Speakflow';
  const affiliate = props.current_affiliate;
  const impersonating = !!props.impersonating;
  useFlash();
  const navItems = [
    {
      label: 'Dashboard',
      href: affiliate_dashboard_path(),
    },
  ];
  return (
    <div className="min-h-screen bg-surface text-fg antialiased">
      {/* Top navigation */}
      <header className="border-b border-edge-strong">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-8">
              <Link
                href={root_path()}
                className="text-lg font-semibold text-fg tracking-tight"
              >
                {appName}
              </Link>
              <nav className="hidden sm:flex items-center gap-1">
                {navItems.map((item) => {
                  const isActive = url.startsWith(item.href);
                  return (
                    <Link
                      key={item.label}
                      href={item.href}
                      className={cn(
                        'px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                        isActive
                          ? 'text-fg bg-surface-muted'
                          : 'text-fg-secondary hover:text-fg hover:bg-surface-muted',
                      )}
                    >
                      {item.label}
                    </Link>
                  );
                })}
              </nav>
            </div>

            <div className="flex items-center gap-4">
              {affiliate && (
                <>
                  <Avatar
                    src={affiliate.avatar_url}
                    alt={affiliate.name || affiliate.email}
                    size="sm"
                  />
                  <span className="text-sm text-fg-tertiary hidden sm:block">
                    {affiliate.email}
                  </span>
                  {!impersonating && (
                    <Link
                      href={affiliate_sign_out_path()}
                      method="delete"
                      as="button"
                      className="text-sm text-fg-tertiary hover:text-fg transition-colors"
                    >
                      Sign out
                    </Link>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        {/* Mobile nav */}
        <div className="sm:hidden border-t border-neutral-100 px-4 py-2 flex gap-1 overflow-x-auto">
          {navItems.map((item) => {
            const isActive = url.startsWith(item.href);
            return (
              <Link
                key={item.label}
                href={item.href}
                className={cn(
                  'px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors',
                  isActive
                    ? 'text-fg bg-surface-muted'
                    : 'text-fg-secondary hover:text-fg hover:bg-surface-muted',
                )}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      </header>

      <main className="max-w-5xl mx-auto py-8 px-4 sm:px-6 lg:px-8">{children}</main>
      <ImpersonationBanner />
    </div>
  );
}
